import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { ProjectDetailDto } from '../lib/types';

export function useProject(jobNumber: string | null) {
  return useQuery({
    queryKey: ['project', jobNumber],
    queryFn: () => apiClient.get<ProjectDetailDto>(`/api/projects/${jobNumber}`),
    enabled: !!jobNumber,
  });
}
